import { render, staticRenderFns } from "./routeError.vue?vue&type=template&id=56f63b19&scoped=true&"
import script from "./routeError.vue?vue&type=script&lang=js&"
export * from "./routeError.vue?vue&type=script&lang=js&"
import style0 from "./routeError.vue?vue&type=style&index=0&id=56f63b19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f63b19",
  null
  
)

export default component.exports